import { lazy } from "react";
import Loadable from "src/routes/Loadable";

const TelegramGroupsList = Loadable(
  lazy(() => import("src/pages/admin/telegram-groups/index"))
);
const TelegramGroupForm = Loadable(
  lazy(() => import("src/pages/admin/telegram-groups/TelegramGroupForm"))
);

const telegram = [
  {
    path: "telegram-groups",
    children: [
      { path: "", element: <TelegramGroupsList />, index: true },
      { path: "add", element: <TelegramGroupForm /> },
      { path: "edit/:id", element: <TelegramGroupForm /> },
    ],
  },
];

export default telegram;
